// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__i947P","itemWrapper":"Item_itemWrapper__BGfHI","spin":"Item_spin__sxiLs"};